module.exports = __webpack_public_path__ + "assets/favicon.ico?3643a192e95f3e2905fff37bec312c32";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/favicon.ico
// module id = 660
// module chunks = 0